var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechExpoNavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 547,
    height: 549,
    viewBox: "0 0 547 549",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M364.81 0.460938H546.973L364.81 183.051H182.646L364.81 0.460938Z",
    fill: "#F8C81F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M364.385 183.051V365.64L546.975 183.051V0.460938L364.385 183.051Z",
    fill: "#00A650"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M364.385 365.642V548.232L546.975 365.642V183.053L364.385 365.642Z",
    fill: "#0070BC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.218 0.460938H364.381L182.218 183.051H0.0549316L182.218 0.460938Z",
    fill: "#F04019"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechExpoNavIcon);
export default __webpack_public_path__ + "static/media/tech-expo-nav-icon.bd25134936093af85004bb041b64ac83.svg";
export { ForwardRef as ReactComponent };